import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Api } from "../../../BackendApi/api";
import { useNavigate } from "react-router-dom";
import MobileConfirmPopup from "../../../Component/MobileConfirmPopup/MobileConfirmPopup";
import '../MobileCategoryOverlay.css';

const MobileEditCategoryOverlay = ({ category, onClose, onSave }) => {
  const [categoryName, setCategoryName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("Active");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const nameInputRef = useRef(null); 

  // Prefill form when editing
  useEffect(() => {
    if (category) {
      setCategoryName(category.categoryName || "");
      setDescription(category.description || "");
      setStatus(
        category.status === true ||
          category.status === "true" ||
          (typeof category.status === "string" &&
            category.status.toLowerCase() === "active")
          ? "Active"
          : "Deactive"
      );
      setImage(category.image || null);
      setPreview(category.image || null);
    }

    // Always focus first input when overlay opens
    if (nameInputRef.current) {
      nameInputRef.current.focus();
    }
  }, [category]);

  // Handle image selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // Submit updated category
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setPopup({
          show: true,
          message: "Please login first!",
          type: "warning",
        });
        setLoading(false);
        return;
      }

      const payload = {
        _id: category._id,
        CategoryName: categoryName,
        Description: description,
        Status: status === "Active" ? "Active" : "Deactive",
        CategoryImagePath: image
          ? `/images/categories/${image.name}`
          : category.image || "",
      };

      const res = await axios.post(Api.editCategory, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (
        res.data.status === 0 &&
        (res.data.message === "Invalid AuthToken" ||
          res.data.message === "AuthToken is required")
      ) {
        navigate("/");
        return;
      }

      setPopup({
        show: true,
        message: res.data.message || "Category updated successfully!",
        type: "success",
      });
    } catch (error) {
      console.error("❌ Error updating category:", error);
      setPopup({
        show: true,
        message:
          error.response?.data?.message || "Failed to update category",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePopupClose = () => {
    setPopup({ ...popup, show: false });
    if (popup.type === "success") {
      if (onSave) onSave();
      onClose();
    }
  };

  return (
    <div className="mobile-category-overlay">
      <div className="mobile-category-overlay-content">
        <h2>Edit Category</h2>
        <form className="mobile-category-overlay-form" onSubmit={handleSubmit}>
          <label>
            Category Name
            <input
              ref={nameInputRef} 
              type="text"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              required
            />
          </label>

          <label>
            Description
            <input
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            ></input>
          </label>

          <label>
            Status
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              style={{ padding: "10px", width: "100%", marginTop: "5px" }}
            >
              <option value="Active">Active</option>
              <option value="Deactive">Deactive</option>
            </select>
          </label>

          <label>
            Category Image
            <input type="file" accept="image/*" onChange={handleImageChange} />
          </label>

          {preview && (
            <div style={{ marginTop: "10px", textAlign: "center" }}>
              <img
                src={preview}
                alt="Preview"
                style={{ width: "100px", borderRadius: "8px" }}
              />
            </div>
          )}

          <div className="mobile-category-overlay-buttons full-width">
            <button type="button" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>

    <MobileConfirmPopup
        show={popup.show}
        message={popup.message}
        type={popup.type}
        onClose={handlePopupClose}
      />
    </div>
  );
};

export default MobileEditCategoryOverlay;
